/**
 * Production specific configuration
 */

const CONFIG = {
    API_HOST: 'https://pe.protherm.sk/api',
    API_PATH: '/evaluations/',
    APP_ENV: 'production',
    USE_FIXTURES: false,
    development: function() {
        return CONFIG.APP_ENV === 'development';
    },
    production: function() {
        return CONFIG.APP_ENV === 'production';
    }
};

export default CONFIG;



/** WEBPACK FOOTER **
 ** ./src/config/production.js
 **/